import { constrain, Type, Constraint } from 'specified';

const integerSpec = constrain(Type.number, [
    Constraint.number.integer
]);
const positiveIntegerSpec = constrain(integerSpec, [
    Constraint.number.atLeast(0)
]);
const integerAbove0 = constrain(integerSpec, [
    Constraint.number.above(0)
]);
const isoDateSpec = Type.string // @TODO: Need more spec constraints
;
// copied and adapted from the obsolete dateString type https://github.com/tbknl/specified/blob/v0.4.0/src/type.ts
const dateStringSpec = {
    version: 1,
    definition: {
        type: 'dateString'
    },
    eval: (value)=>{
        const ts = Date.parse(`${value}`);
        if (ts % 1 !== 0) {
            return {
                err: {
                    code: 'type.dateString.not_valid',
                    value,
                    message: 'Not a valid date.'
                }
            };
        }
        return {
            err: null,
            value: new Date(ts)
        };
    }
};
/**
 * This constraint is copied from the customer-service, here: https://github.com/GrandVisionHQ/customer-service/blob/edd52993ff3b36fdb7472dd0eb4441fd31c41777/src/interface/models.ts#L21-L23
 * Explanation of regex: https://stackoverflow.com/questions/46155/how-to-validate-an-email-address-in-javascript
 */ Constraint.string.regex(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

export { dateStringSpec, integerAbove0, integerSpec, isoDateSpec, positiveIntegerSpec };
//# sourceMappingURL=specs-utils.js.map
